<template>
  <div  :style="{height: (height - 82) + 'px'}">
    <SystemName :title="title" :is-small="isSmall"></SystemName>
    <div style="height: 351px;" v-if="isSmall">
      <lay-quote style="background-color: transparent;color: #ccc;border-top: 1px solid #16b777;border-bottom: 1px solid #16b777">水埠乙线</lay-quote>
      <DataTable style="" :items="[{'title': '1#进线柜'},{'title': '2#变压器出线柜'},{'title': '4#变压器出线柜'},{'title': '6#变压器出线柜'},{'title': '8#变压器出线柜'},{'title': '10#变压器出线柜'},{'title': '备用'}]"
                 :dataset="[{data: data['11']},{data: data['12']},{data: data['21']},{data: data['31']},{data: data['41']},{data: data['51']},{data: data['111']}]"
                 :content-style="{'margin':'0 auto'}"
                 :wrap="true"
                 :interval="['0px', '0px']"></DataTable>
      <lay-quote style="background-color: transparent;color: #ccc;border-top: 1px solid #16b777;border-bottom: 1px solid #16b777;margin-top: 10px">水埠甲线</lay-quote>
      <DataTable style="" :items="[{'title': '备用'},{'title': '9#变压器出线柜'},{'title': '7#变压器出线柜'},{'title': '5#变压器出线柜'},{'title': '3#变压器出线柜'},{'title': '1#变压器出线柜'},{'title': '2#进线柜'}]"
                 :dataset="[{data: data['211']},{data: data['61']},{data: data['71']},{data: data['81']},{data: data['91']},{data: data['101']},{data: data['20']}]"
                 :content-style="{'margin':'0 auto'}"
                 :wrap="true"
                 :interval="['0px', '0px']"></DataTable>
    </div>
    <div style="height: 351px;width: 1500px;margin: 50px auto 0px" v-else>
      <lay-row space="10">
        <lay-col xs="24" md="24" sm="24" lg="24">
          <div  style="height: 351px;margin-left: 66px" >
            <lay-space :size="['0px', '0px']">
              <BusLine :bus-style="{'width': '110px', 'margin-left': '-60px'}"></BusLine>
              <BusLine :bus-style="{'width': '1320px', 'margin-left': '40px'}"></BusLine>
            </lay-space>
            <div style="margin-top: -3px;" >
              <lay-space :size="['0px', '0px']" >
                <MetaNode  styleClass="G01" :on-off-style="[G01, on_off_status ? OFF : '']"   :node-infos="[{'nodeTitle': 'G01', 'nodeTitleMl': '12', 'nodeName': '水埠乙线 1#进线柜', 'nodeNameMl': '-55'},{'nodeTitle': '', 'nodeTitleMl': '33', 'nodeName': '1#计量柜', 'nodeNameMl': '16'}]" >
                  <MetaNode styleClass="blg_left" :on-off-style="{'display': 'none'}" :node-infos="[]" ></MetaNode>
                </MetaNode>
                <MetaNode styleClass="G04" :on-off-style="[G04, on_off_status ? OFF : '']" :node-infos="[{'nodeTitle': 'G03', 'nodeTitleMl': '6', 'nodeName': '2#变压器出线柜', 'nodeNameMl': '-29', 'nodeNameWidth': '110'}]" ></MetaNode>
                <MetaNode styleClass="G04" :on-off-style="[G04, on_off_status ? OFF : '']" :node-infos="[{'nodeTitle': 'G04', 'nodeTitleMl': '6', 'nodeName': '4#变压器出线柜', 'nodeNameMl': '-29', 'nodeNameWidth': '110'}]"></MetaNode>
                <MetaNode styleClass="G04" :on-off-style="[G04, on_off_status ? OFF : '']" :node-infos="[{'nodeTitle': 'G05', 'nodeTitleMl': '6', 'nodeName': '6#变压器出线柜', 'nodeNameMl': '-29', 'nodeNameWidth': '110'}]" ></MetaNode>
                <MetaNode styleClass="G04" :on-off-style="[G04, on_off_status ? OFF : '']" :node-infos="[{'nodeTitle': 'G06', 'nodeTitleMl': '6', 'nodeName': '8#变压器出线柜', 'nodeNameMl': '-29', 'nodeNameWidth': '110'}]" ></MetaNode>
                <MetaNode styleClass="G04" :on-off-style="G04_DIS_CON" :node-infos="[{'nodeTitle': 'G08', 'nodeTitleMl': '6', 'nodeName': '10#变压器出线柜', 'nodeNameMl': '-33', 'nodeNameWidth': '120'}]" ></MetaNode>
                <MetaNode styleClass="G04" :on-off-style="G04_DIS_CON" :node-infos="[{'nodeTitle': 'G09', 'nodeTitleMl': '6', 'nodeName': '备用', 'nodeNameMl': '4'}]" ></MetaNode>
              </lay-space>
            </div>
          </div>
          <DataTable style="margin-left: 55px" :items="[{'title': '1#进线柜'},{'title': '2#变压器出线柜'},{'title': '4#变压器出线柜'},{'title': '6#变压器出线柜'},{'title': '8#变压器出线柜'},{'title': '10#变压器出线柜'},{'title': '备用'}]"
                     :dataset="[{data: data['11']},{data: data['12']},{data: data['21']},{data: data['31']},{data: data['41']},{data: data['51']},{data: data['111']}]"
                     :content-style="{'width': '600px', 'margin':'50px 0px 0px 70px'}"
                     :interval="['0px', '0px']"></DataTable>
        </lay-col>
        <lay-col xs="24" md="24" sm="24" lg="24" style="margin-top: 60px">
          <div  style="height: 351px;margin-left: 30px" >
            <lay-space :size="['0', '0px']" >
              <BusLine :bus-style="{'width': '1370px', 'margin-left': '20px'}"></BusLine>
              <BusLine :bus-style="{'width': '110px', 'margin-left': '40px'}"></BusLine>
            </lay-space>
            <div style="margin-top: -3px" >
              <lay-space :size="['0px', '0px']"  >
                <MetaNode styleClass="G08" :on-off-style="[...G08, DIS_CONN]" :node-infos="[{'nodeTitle': 'G10', 'nodeTitleMl': '28', 'nodeName': '备用', 'nodeNameMl': '26'}]" ></MetaNode>
                <MetaNode styleClass="G08" :on-off-style="[...G08, on_off_status ? '' : OFF]" :node-infos="[{'nodeTitle': 'G11', 'nodeTitleMl': '30', 'nodeName': '9#变压器出线柜', 'nodeNameMl': '-9', 'nodeNameWidth': '110'}]"></MetaNode>
                <MetaNode styleClass="G08" :on-off-style="[...G08, on_off_status ? '' : OFF]" :node-infos="[{'nodeTitle': 'G12', 'nodeTitleMl': '30', 'nodeName': '7#变压器出线柜', 'nodeNameMl': '-9', 'nodeNameWidth': '110'}]" ></MetaNode>
                <MetaNode styleClass="G08" :on-off-style="[...G08, on_off_status ? '' : OFF]" :node-infos="[{'nodeTitle': 'G13', 'nodeTitleMl': '28', 'nodeName': '5#变压器出线柜', 'nodeNameMl': '-9', 'nodeNameWidth': '110'}]" ></MetaNode>
                <MetaNode styleClass="G08" :on-off-style="[...G08, on_off_status ? '' : OFF]" :node-infos="[{'nodeTitle': 'G14', 'nodeTitleMl': '30', 'nodeName': '3#变压器出线柜', 'nodeNameMl': '-9', 'nodeNameWidth': '110'}]"></MetaNode>
                <MetaNode styleClass="G08" :on-off-style="[...G08, on_off_status ? '' : OFF]" :node-infos="[{'nodeTitle': 'G15', 'nodeTitleMl': '30', 'nodeName': '1#变压器出线柜', 'nodeNameMl': '-9', 'nodeNameWidth': '110'}]" ></MetaNode>
                <MetaNode styleClass="G12" :on-off-style="[...G12, on_off_status ? '' : OFF]" :node-infos="[{'nodeTitle': '', 'nodeTitleMl': '27', 'nodeName': '2#计量柜', 'nodeNameMl': '10'}, {'nodeTitle': 'G18', 'nodeTitleMl': '38', 'nodeName': '2#进线柜', 'nodeNameMl': '21'}]" >
                  <MetaNode styleClass="blg_right" :on-off-style="{'display': 'none'}" :node-infos="[{'nodeName': '水埠甲线', 'nodeNameMl': '-35'}]" ></MetaNode>
                </MetaNode>
              </lay-space>
            </div>
          </div>
          <DataTable style="margin-left: 50px" :items="[{'title': '备用'},{'title': '9#变压器出线柜'},{'title': '7#变压器出线柜'},{'title': '5#变压器出线柜'},{'title': '3#变压器出线柜'},{'title': '1#变压器出线柜'},{'title': '2#进线柜'}]"
                     :dataset="[{data: data['211']},{data: data['61']},{data: data['71']},{data: data['81']},{data: data['91']},{data: data['101']},{data: data['20']}]"
                     :content-style="{'width': '600px', 'margin':'50px 0px 0px 20px'}"
                     :interval="['0px', '0px']"></DataTable>
        </lay-col>
      </lay-row>

    </div>
  </div>
</template>

<script setup>
import {useSize} from "@/assets/js/size";
import SystemName from "@/components/system/SystemName";
import MetaNode from "@/components/system/MetaNode";
import BusLine from "@/components/system/BusLine";
import DataTable from "@/components/DataTable";
import axios from "axios";
import {computed, ref} from "vue";
import {useInterval} from "@/assets/js/interval";
const {height, width} = useSize();
const isSmall = computed(() => width.value <= 768)
const title = '青岛福州路万科中心35KV变电站主接线图'
const onOffTop = {'top': '34px'}
const G08_left = {'left': '44px'}
const G04_left = {'left': '21px'}
const OFF = {'background-color': '#00FF00'};
const DIS_CONN = {'background-color': '#999'};
const G01 = [{'left': '19px'}, onOffTop];
const G04 = [G04_left, onOffTop];
// const G04_OFF = [...G04, OFF];
const G04_DIS_CON = [...G04, DIS_CONN];
const G08 = [G08_left, onOffTop];
const G12 = [{'left': '128px'}, onOffTop];
// const LINE_1 = ['11','12','21','31','41'];
const LINE_2 = {
  '61': false,'71' : false ,'81': false,'91': false,'101': false,'20':false
}
const on_off_status = ref(false); //2#进线状态

const data = ref({});



const realtime_data = function (){
  axios.get('/realtime/data?page_id=0')
      .then(function (response) {
        if (response.data.code == 0){
          data.value = response.data.data;
          let count_i = 0;
          for (let key of Object.keys(LINE_2)){
           if (parseFloat(data.value[key]['ib']) > 0){
             count_i++;
           }
          }
          on_off_status.value = count_i > 3;
        }
      })
      .catch(function () {
      }).finally(() => {

  });
}

useInterval(realtime_data, 5000);

</script>

<style scoped>
.blg_left{
  width: 35px;
  height: 174px;
  margin-left: -70px;
  background: url("../../assets/img/blq_left.png") no-repeat;
}
.blg_right{
  width: 35px;
  height: 174px;
  margin-left: 197px;
  background: url("../../assets/img/blq_right.png") no-repeat;
}
.G01{
  width: 160px;
  height: 203px;
  background: url("../../assets/img/G01_G02.png") no-repeat;
}
.G04{
  width: 79px;
  height: 351px;
  margin-left: 130px;
  background: url("../../assets/img/G04.png") no-repeat;
}
.layui-space-align-center{
  align-items: flex-start;
}
.G08{
  width: 90px;
  height: 351px;
  margin-right: 130px;
  background: url("../../assets/img/G08.png") no-repeat;
}
.G12{
  background: url('../../assets/img/G12.png') no-repeat;
  width: 167px;
  height: 203px;
}
</style>